import DataTable from "react-data-table-component";

const DataTableComponent = ({ columns, data }) => {
  return (
    <>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 30]}

      />
    </>
  );
};

export default DataTableComponent;
